// src/components/QuetionModal.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { TreeSelect, Select, Button, Form, Modal, Input, Row, Col, Upload, AudioFilled, Radio, Textarea, InputNumber, UploadImg, DatePicker } from '../ui/ot';
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';
import { useSmartTaskSchedulingTaskCategory } from "../pmis/controller/smart_task_scheduling_task_category_controller";
import { useSmartTaskSchedulingTaskPriority } from "../pmis/controller/smart_task_scheduling_task_priority_controller";
import { useSmartTaskSchedulingTaskLabel } from "../pmis/controller/smart_task_scheduling_task_label_controller";
import { useSmartTaskSchedulingTaskStatus } from "../pmis/controller/smart_task_scheduling_task_status_controller";


const LanguageContext = createContext(null)

const TaskModal = ({
    keyPrefix = "pmis.smartTaskSchedulingTask",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => {

    },
    onFinish = () => {

    },
    reloadTable = () => { },
    modalStyle = {},
    openButtonStyle = {
        backgroundColor: "#fff8c8",
        color: "#000"
    },
    openButtontext = "新增標籤分類",
    title = "新增標籤分類",
    customFormItems = () => { },
    showDefaultFormItems = [],
    propsShowKeys,
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const axiosModelanguage = {
        post: t('post'),
        patch: t('edit')
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])


    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }

            <Modal
                style={{ top: 10, }}
                contentStyle={{ padding: 16 }}
                width={1000}
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                okText={t('ok')}
                cancelText={t('cancel')}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row
                >
                    <Col span={24}>
                        <TaskForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                            customFormItems={customFormItems}
                            propsShowKeys={propsShowKeys}
                        // showDefaultFormItems={showDefaultFormItems}                
                        />
                    </Col>
                </Row>
            </Modal>
        </LanguageContext.Provider>
    </>);
};
export default TaskModal;



const TaskForm = ({
    keyPrefix = "pmis.smartTaskSchedulingTask",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    defaultValue = {},
    field,
    fieldName = field?.name,
    hasValue = false,
    customFormItems = () => { },
    initialValues = [],
    propsShowKeys = [
        { key: "task_name", name: "task_name", hidden: false, require: false },
        { key: "task_explaination", name: "task_explaination", hidden: false, require: false },
        { key: "person_in_charge", name: "person_in_charge", hidden: false, require: false },
        { key: "start_time", name: "start_time", hidden: false, require: false },
        { key: "end_time", name: "end_time", hidden: false, require: false },
        { key: "progress", name: "progress", hidden: false, require: false },
        { key: "category_name", name: "category_name", hidden: false, require: false },
        { key: "priority_name", name: "priority_name", hidden: false, require: false },
        { key: "label_name", name: "label_name", hidden: false, require: false },
        { key: "status_name", name: "status_name", hidden: false, require: false },
    ],
    formMode = false,
    formOnValuesChange = () => { },
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [currentKey_, setCurrentKey] = useState([])
    const currentKey = propsShowKeys ?? currentKey_;
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        // getSmartTaskSchedulingTaskCategoryData({ "category_id": propsForm.getFieldValue('category_id') })
        getSmartTaskSchedulingTaskCategoryData()
        getSmartTaskSchedulingTaskPriorityData()
        // getSmartTaskSchedulingTaskLabelData({ "label_id": propsForm.getFieldValue('label_id') })
        getSmartTaskSchedulingTaskLabelData()
        getSmartTaskSchedulingTaskStatusData()
    }
    const onFinish = () => {
        const values = getFormValues()
        console.log(values)
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props } = {}) => {
        let formValues = null
        if (fieldName) {
            formValues = form.getFieldValue(fieldName)
        } else {
            formValues = form.getFieldsValue()
        }
        if (formMode) {
            formOnValuesChange(e, { name, ...props } = {})
        }
        if (!formMode) {
            propsOnValuesChange({
                ...formValues,
                // ...e
            })
        }
    }

    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };
    const {
        smartTaskSchedulingTaskCategoryData,
        getSmartTaskSchedulingTaskCategoryData,
    } = useSmartTaskSchedulingTaskCategory({});
    const {
        smartTaskSchedulingTaskPriorityData,
        getSmartTaskSchedulingTaskPriorityData,
    } = useSmartTaskSchedulingTaskPriority({});
    const {
        smartTaskSchedulingTaskLabelData,
        getSmartTaskSchedulingTaskLabelData,
    } = useSmartTaskSchedulingTaskLabel({});
    const {
        smartTaskSchedulingTaskStatusData,
        getSmartTaskSchedulingTaskStatusData,
    } = useSmartTaskSchedulingTaskStatus({});

    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])
    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                name={fieldName ? [fieldName, "task_id"].join('.') : "task_id"}

                            >
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "task_name"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('task_name')}
                                name={fieldName ? [fieldName, "task_name"].join('.') : "task_name"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "task_name"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <Input disabled={hasValue} />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "task_explaination"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('task_explaination')}
                                name={fieldName ? [fieldName, "task_explaination"].join('.') : "task_explaination"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "task_explaination"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <Input disabled={hasValue} />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "person_in_charge"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('person_in_charge')}
                                name={fieldName ? [fieldName, "person_in_charge"].join('.') : "person_in_charge"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "person_in_charge"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <Input disabled={hasValue} />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "executor"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('executor')}
                                name={fieldName ? [fieldName, "executor"].join('.') : "executor"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "executor"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <Input disabled={hasValue} />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "start_time"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('start_time')}
                                name={fieldName ? [fieldName, "start_time"].join('.') : "start_time"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "start_time"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <DatePicker.Time />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "end_time"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('end_time')}
                                name={fieldName ? [fieldName, "end_time"].join('.') : "end_time"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "end_time"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <DatePicker.Time />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "progress"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('progress')}
                                name={fieldName ? [fieldName, "progress"].join('.') : "progress"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "progress"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                {/* <Input disabled={hasValue} /> */}
                                <InputNumber disabled={hasValue} min={0} max={100} value={0} />
                            </Form.Item>
                        </Col>

                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "category_name"
                            })?.hidden}
                        >
                            <Form.List
                                label={t("category_name")}
                                name={fieldName ? [fieldName, "category_id"].join('.') : "category_id"}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "category_name"
                                        })?.require,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >

                                {(subFields, { add, remove }) => (
                                    <Row>
                                        <Col span={24}>
                                            <Button onClick={
                                                () => {
                                                    add();
                                                }
                                            }
                                                hidden={currentKey?.find((element) => {
                                                    return element.name === "category_name"
                                                })?.hidden}
                                            >{t("post_category_name")}</Button>
                                        </Col>
                                        {subFields?.map((subField, key) => (<>
                                            {/* <Col span={24}>{console.log(field)}</Col> */}
                                            <Col span={1}>{`${key + 1}`}</Col>
                                            <Col span={23}>
                                                <Form.Item
                                                    label={t("category_name")}
                                                    name={[subField.name, 'category_id']}
                                                    rules={[
                                                        {
                                                            required: currentKey?.find((element) => {
                                                                return element.name === "category_name"
                                                            })?.require,
                                                            message: `此為必填項目`
                                                        }
                                                    ]}
                                                    hidden={currentKey?.find((element) => {
                                                        return element.name === "category_name"
                                                    })?.hidden}
                                                >
                                                    <Select
                                                        style={{
                                                            maxHeight: "80vh",
                                                            minHeight: "20vh",
                                                            overflowX: "scroll",
                                                            overflowY: "scroll",
                                                        }}
                                                        options={smartTaskSchedulingTaskCategoryData.map(item => (
                                                            {
                                                                label: item?.category_name,
                                                                value: item?.category_id,
                                                            }
                                                        ))}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </>))}
                                    </Row>
                                )}
                            </Form.List>
                        </Col>

                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "priority_name"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('priority_name')}
                                name={fieldName ? [fieldName, "priority_id"].join('.') : "priority_id"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "priority_name"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <Select
                                    style={{
                                        maxHeight: "80vh",
                                        minHeight: "20vh",
                                        overflowX: "scroll",
                                        overflowY: "scroll",
                                    }}
                                    options={smartTaskSchedulingTaskPriorityData.map(item => (
                                        {
                                            label: item?.priority_name,
                                            value: item?.priority_id,
                                        }
                                    ))}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "label_name"
                            })?.hidden}
                        >
                            <Form.List
                                label={t("label_name")}
                                name={fieldName ? [fieldName, "label_id"].join('.') : "label_id"}
                                rules={[
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "label_name"
                                        })?.require,
                                        message: `此為必填項目`
                                    }
                                ]}
                            >

                                {(subFields, { add, remove }) => (
                                    <Row>
                                        <Col span={24}>
                                            <Button onClick={
                                                () => {
                                                    add();
                                                }
                                            }
                                                hidden={currentKey?.find((element) => {
                                                    return element.name === "label_name"
                                                })?.hidden}
                                            >{t("post_label_name")}</Button>
                                        </Col>
                                        {subFields?.map((subField, key) => (<>
                                            {/* <Col span={24}>{console.log(field)}</Col> */}
                                            <Col span={1}>{`${key + 1}`}</Col>
                                            <Col span={23}>
                                                <Form.Item
                                                    label={t("label_name")}
                                                    name={[subField.name, 'label_id']}
                                                    rules={[
                                                        {
                                                            required: currentKey?.find((element) => {
                                                                return element.name === "label_name"
                                                            })?.require,
                                                            message: `此為必填項目`
                                                        }
                                                    ]}
                                                    hidden={currentKey?.find((element) => {
                                                        return element.name === "label_name"
                                                    })?.hidden}
                                                >
                                                    <Select
                                                        style={{
                                                            maxHeight: "80vh",
                                                            minHeight: "20vh",
                                                            overflowX: "scroll",
                                                            overflowY: "scroll",
                                                        }}
                                                        options={smartTaskSchedulingTaskLabelData.map(item => (
                                                            {
                                                                label: item?.label_name,
                                                                value: item?.label_id,
                                                            }
                                                        ))}
                                                    />
                                                </Form.Item>
                                            </Col>
                                        </>))}
                                    </Row>
                                )}
                            </Form.List>
                        </Col>
                        <Col span={24}
                            hidden={currentKey?.find((element) => {
                                return element.name === "status_name"
                            })?.hidden}
                        >
                            <Form.Item
                                label={t('status_name')}
                                name={fieldName ? [fieldName, "status_id"].join('.') : "status_id"}
                                rules={!hasValue ? [
                                    {
                                        required: currentKey?.find((element) => {
                                            return element.name === "status_name"
                                        })?.require,
                                        message: "請輸入"
                                    }
                                ] : []}
                            >
                                <Select
                                    style={{
                                        maxHeight: "80vh",
                                        minHeight: "20vh",
                                        overflowX: "scroll",
                                        overflowY: "scroll",
                                    }}
                                    options={smartTaskSchedulingTaskStatusData.map(item => (
                                        {
                                            label: item?.status_name,
                                            value: item?.status_id,
                                        }
                                    ))}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form, field, onFormFinish)}
                </Form>
            </Col>
        </Row>
    </>
}
export { TaskForm }

